import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { ApiService } from 'app/api.service';
import { LoaderService } from 'app/loader.service';

@Component({
  selector: 'app-become',
  templateUrl: './become.component.html',
  styleUrls: ['./become.component.scss']
})
export class BecomeComponent implements OnInit {
  private Parse: any = require('parse');

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public apiService: ApiService,
    private loaderService: LoaderService
  ) { }

  ngOnInit() {
    let router = this.router;

    this.loaderService.setLoaded();

    if (this.route.snapshot.params.sessionToken !== '' && typeof(this.route.snapshot.params.sessionToken) !== 'undefined') {
      this.apiService.Parse.User.become(this.route.snapshot.params.sessionToken).then(function (user) {
        router.navigate(['/home']);
      }, function (error) {
        this.router.navigate(['/']);
      });
    } else {
      this.router.navigate(['/']);
    }
  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/become/become.component.ts